export const ACTION_PREFIX = 'CAPTURE_DIRECTOR';

export const actionTypes = {
  UPDATE_ERROR_MESSAGE: 'UPDATE_ERROR_MESSAGE',
};
